const state={
  mobileUserName:'defaultval'
};

// 类似于sate属性的computed用法
const getters={
  doubleName(){
    return state.mobileUserName + state.mobileUserName
  }
};

// 具体操作state中属性的方法
const mutations={
  changeNameMutation(state,name){
    state.mobileUserName = name
  }
};

// 正规情况下往外暴露的方法，内部调用mutation中的方法
const actions={
  changeNameAction(context,val){
    context.commit('changeNameMutation',val)
  }
};

export default {
  namespaced:true,//用于在全局引用此文件里的方法时标识这一个的文件名
  state,
  getters,
  mutations,
  actions
}